import React from 'react';

const FooterPolicy = () => {
  return (
    <div className="text-sm text-gray-600 space-y-6 p-6 max-w-4xl mx-auto">
      <h2 className="text-xl font-semibold text-gray-800">Diviseed – Privacy Policy & Terms of Service</h2>

      <section>
        <h3 className="font-semibold text-gray-700">Privacy Policy</h3>
        <ul className="list-disc pl-5 space-y-2">
          <li>We collect your name and email for registration. Payments are processed by Stripe; we do not store your payment info.</li>
          <li>Your data is used to manage your account, communicate updates, and improve the service.</li>
          <li>We share data only with necessary providers (like Stripe) or when legally required.</li>
          <li>We retain your info while your account is active.</li>
          <li>You can request access, changes, or deletion of your data.</li>
          <li>We use standard security practices to protect your info.</li>
          <li>User-uploaded data (e.g. earnings, performance metrics) is stored securely and used only to provide personalized insights, analytics, or benchmarking.</li>
          <li>You retain ownership of uploaded data. You may request deletion at any time.</li>
          <li>We may use anonymized, aggregated data for research, benchmarking, or product improvement.</li>
          <li>We may update this policy from time to time.</li>
        </ul>
      </section>

      <section>
        <h3 className="font-semibold text-gray-700">Terms of Service</h3>
        <ul className="list-disc pl-5 space-y-2">
          <li>You must register with accurate info and maintain account security.</li>
          <li>Plans are billed via Stripe. Subscription fees are non-refundable unless legally required.</li>
          <li>Use of the service must comply with laws and cannot disrupt or misuse the platform.</li>
          <li>You retain ownership of your data. Diviseed may reference public data (e.g., from Turo). We are not affiliated with Turo.</li>
          <li>All rights to the platform belong to Diviseed; use is licensed and revocable.</li>
          <li>We may suspend or terminate accounts for violations.</li>
          <li>Diviseed is not liable for indirect damages.</li>
          <li>These terms may be updated at any time.</li>
        </ul>
      </section>

      <div className="pt-4 text-gray-700">
        Contact: <a href="mailto:support@diviseed.io" className="text-blue-600 hover:underline">diviseedanalytics@gmail.com</a>
      </div>
    </div>
  );
};


export default FooterPolicy;
